//事件
const EVENTS = {
    
    state: 'state',                             //播放器生命周期状态
    videoInfo: 'videoInfo',                     //视频信息
    audioInfo: 'audioInfo',                     //音频信息
    error: 'error',                             //出错信息
    playbackTimestamp :'playbackTimestamp',     //回放时间戳
    recordState: 'recordState',                 //录像状态
    recordingTimestamp :'recordingTimestamp',   //录像时间戳 
    updateOptions: 'updateOptions',             //更新参数
    talkState: 'talkState',                     //对讲状态
    stats :'stats',                             //统计信息

}

/*

*/

const EVENT_STATE = {
    
    init: 0,         //初始化
    fetchStream: 1,  //获取流
    play: 2,         //开始播放
    pause: 3,        //暂停
    interupt: 5,      //中断
    pauseAudio:6,    //结束对讲
    resumeAudio:7   //开始对讲
}


const EVENT_TALKSTATE = {

    start: 1,        //对讲开始
    stop: 2,         //对讲结束
}



const EVENT_RECORDSTATE = {
    
    start: 1,         //开始录像
    stop: 2,          //停止录像
}




export {EVENTS, EVENT_STATE, EVENT_RECORDSTATE, EVENT_TALKSTATE};